import Vue from "vue";
import VueRouter from "vue-router";
const originalPush = VueRouter.prototype.push;
const flag = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
//console.log(flag);
const routes = [
  {
    path: "",
    redirect: "/dologin",
  },

  {
    path: "/dologin",
    name: "dologin",
    component: () => import("../views/doLogin.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/loading",
    name: "loading",
    component: () => import("../views/loadingPage/loadingPage"),
    meta: {
      title: "加载中",
    },
  },
  {
    path: "/Home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    children: [
      {
        path: "",
        redirect: "/Home/userList",
      },
      {
        path: "userList",
        name: "userList",
        component: () => import("../views/user/userList"),
      },
      {
        path: "department",
        name: "department",
        component: () => import("../views/department/department"),
      },

      {
        path: "authority",
        name: "authority",
        component: () => import("../views/authority/authority"),
      },
      {
        path: "role",
        name: "role",
        component: () => import("../views/authority/role"),
      },
      {
        path: "courseResourceManagement",
        name: "courseResourceManagement",
        component: () => import("../views/courseResourceManagement/courseResourceManagement"),
      },
      {
        path: "courseCategory",
        name: "courseCategory",
        component: () => import("../views/courseCategory/courseCategory"),
      },
      {
        path: "courseCenter",
        name: "courseCenter",
        component: () => import("../views/courseCenter/courseCenter"),
      },
      {
        path: "lecturerCategory",
        name: "lecturerCategory",
        component: () => import("../views/lecturerCategory/lecturerCategory"),
      },
      {
        path: "lecturerLabel",
        name: "lecturerLabel",
        component: () => import("../views/lecturerLabel/lecturerLabel"),
      },
      {
        path: "lecturerResource",
        name: "lecturerResource",
        component: () => import("../views/lecturerResource/lecturerResource"),
        meta: {
          title: '讲师资源'
        },
        children: [
          {
            path: "",
            redirect: "/Home/lecturerResource/lecturerDetail"
          },
          {
            path: "lecturerDetail",
            name: "lecturerDetail",
            component: () => import("../views/lecturerResource/lecturerDetail"),
            meta: {
              title: '讲师名录'
            }
          },
          {
            path: "yearView",
            name: "yearView",
            component: () => import("../views/lecturerResource/YearView"),
            meta: {
              title: '全年视图'
            }
          },
          {
            path: "monthView",
            name: "monthView",
            component: () => import("../views/lecturerResource/MonthView"),
            meta: {
              title: '全员档期'
            }
          }
        ]
      },
      {
        path: "lecturer",
        name: "lecturer",
        component: () => import("../views/lecturer/lecturer"),
      },
      {
        path: "courseSuitableUser",
        name: "courseSuitableUser",
        component: () => import("../views/courseSuitableUser/courseSuitableUser"),
      },
      {
        path: "existingLog",
        name: "existingLog",
        component: () => import("../views/sysLog/existingLog"),
      },
      {
        path: "logActivityStatistics",
        name: "logActivityStatistics",
        component: () => import("../views/sysLog/logActivityStatistics"),
      },
      {
        path: "SystemLog",
        name: "SystemLog",
        component: () => import("../views/sysLog/SystemLog"),
      },
      {
        path: "commentManagement",
        name: "commentManagement",
        component: () => import("../views/commentManagement/commentManagement"),
      },
      {
        path: "feedbackManagement",
        name: "feedbackManagement",
        component: () => import("../views/sysFeedback/FeedbackManagement"),
        meta: {
          title: '反馈管理'
        }
      },
      {
        path: "activityManagement",
        name: "activityManagement",
        component: () => import("../views/activityManagement/activityManagement"),
        meta: {
          title: '活动管理'
        }
      },
      {
        path: "activityCategory",
        name: "activityCategory",
        component: () => import("../views/activityCategory/activityCategory"),
        meta: {
          title: '活动分类'
        }
      },
      {
        path: "activityResource",
        name: "activityResource",
        component: () => import("../views/activityResource/activityResource"),
        meta: {
          title: '活动资源'
        }
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
